<template>
<div title="Estudiantes">
    <vs-button type="border" color="success" class="mr-2" to="/usuario/nuevo">Agregar</vs-button>
    <vs-table :data="estudiante" class="mt-4">
        <template slot="thead">
            <vs-th>Nombres</vs-th>
            <vs-th>Accesos</vs-th>
            <vs-th>Fecha de Creacion</vs-th>
            <vs-th>Acciones</vs-th>
        </template>
        <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="tr.nombre">
                    {{tr.nombre}}
                    {{tr.apellido}}
                </vs-td>

                <vs-td :data="tr.cedula">
                    Usuario:
                    {{tr.email}} <br>
                    Clave:
                    {{tr.cedula}}
                </vs-td>

                <vs-td :data="tr.fecha_create">
                    {{tr.fecha_create}}
                </vs-td>

                <vs-td :data="tr.idusuario">
                    <div class="flex">
                        <vs-button type="border" size="small" icon-pack="feather" icon="icon-edit" class="mr-2" color="success" @click="getEditar(tr.idusuario)"></vs-button>
                        <vs-button type="border" size="small" icon-pack="feather" icon="icon-x" class="mr-2" color="danger" @click="getConfirmaEliminar(tr.idusuario)"></vs-button>
                    </div>
                </vs-td>

            </vs-tr>
        </template>
    </vs-table>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    data() {
        return {
            estudiante: [],
        }
    },
    mounted() {
        this.getDocentes();
    },
    methods: {
        getDocentes() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'estudianteXinsitucion/' + localStorage.idinstitucion)
                .then(response => {
                    me.estudiante = response.data;
                    // console.log(me.estudiante);
                    me.$vs.loading.close();
                })
                .catch(() => {
                    me.$vs.loading.close();
                })
        },
        getEditar(estudiante) {
            this.$router.push('/estudiante/editar/' + estudiante);
            // console.log(estudiante);
        },
        getConfirmaEliminar(item) {
            let me = this;
            me.datoDesactivar = item;
            // console.log(me.datoDesactivar)
            me.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirma desactivar',
                text: "Seguro desea desactivar este registro",
                acceptText: 'Si, desactivar',
                accept: me.getEliminar,
            });
        },
        getEliminar() {
            let me = this;
            me.$http.get(this.$server_url + 'desactivarUsuario/' + me.datoDesactivar)
                .then(() => {
                    me.getDocentes();
                })
                .catch(() => {})
        }
    },
}
</script>
